module.exports = __webpack_public_path__ + "img/mes_annonces.28ab80dd.png";